import { Skeleton } from '@view/view_booking/components/skeleton';
import { ViewBookingSetup } from '@view/view_booking/screens/screen_setup';
import { ViewNotFound } from '@view/view_not_found/view_not_found_route.component';
import { Route, Routes } from 'react-router';
import { useBooking } from '../hooks/use_booking';
import { useBookingBasket } from '../hooks/use_booking_basket';
import { useBookingRouteSetup } from '../hooks/use_booking_route_setup';
import { ScreenAccess } from '../screens/screen_access';
import { ScreenConclusion } from '../screens/screen_conclusion';
import { ScreenDone } from '../screens/screen_done';
import { ScreenError } from '../screens/screen_error';
import { ScreenForms } from '../screens/screen_forms';
import { ScreenLocation } from '../screens/screen_location';
import { ScreenReasonForVisit } from '../screens/screen_reason_for_visit';
import { ScreenTimeSlot } from '../screens/screen_time_slot';
import { ScreenUnauthorized } from '../screens/screen_unauthorized';
import { ScreenWhoIsRespondant } from '../screens/screen_who_is_respondant';

export const ViewBookingRoutes = () => {
	const viewBooking = useBooking();
	const bookingBasket = useBookingBasket();
	useBookingRouteSetup();

	if (viewBooking.flowSettings.value === 'Unauthorized') {
		return <ScreenUnauthorized />;
	}

	if (viewBooking.flowSettings.status === 'error') {
		return <ScreenError error={viewBooking.flowSettings.value} />;
	}

	return (
		<Routes>
			<Route index element={<ViewBookingSetup />} />
			{bookingBasket.basketReady && viewBooking.flowSettings.status === 'accessible' ? (
				<>
					<Route path='/who-is-respondant/*' element={<ScreenWhoIsRespondant />} />
					<Route path='/reason-for-visit/*' element={<ScreenReasonForVisit />} />
					<Route path='/location/*' element={<ScreenLocation />} />
					<Route path='/time-slot/*' element={<ScreenTimeSlot />} />
					<Route path='/forms/*' element={<ScreenForms />} />
					<Route path='/access/*' element={<ScreenAccess />} />
					<Route path='/conclusion/*' element={<ScreenConclusion />} />
					<Route path='/done/*' element={<ScreenDone />} />
					<Route path='/error/*' element={<ScreenError />} />
					<Route path='/*' element={<ViewNotFound />} />
				</>
			) : (
				<Route path='*' element={<Skeleton />} />
			)}
		</Routes>
	);
};
